module.exports = __webpack_public_path__ + "static/uxfellowsContact-0d48748b5e0202f3c86aaae38281e08f.png";